import { isWindows } from 'Utilities'
import FigureCaption from 'Chats/FigureCaption.vue'
import Slider from 'UtilityComponents/Slider.vue'

export default {
  props: {
    chat: { type: Object, required: true },
    operatorName: { type: String, required: true }
  },
  computed: {
    manualSliderMode() {
      const win = isWindows()
      return win
    }
  },
  components: {
    FigureCaption,
    Slider
  },
  methods: {
    move(direction) {
      const spacer = this.$refs.spacer.offsetWidth
      let item = 0
      this.$refs.slides.some((slide) => {
        item = slide.offsetWidth || slide.$el.offsetWidth
        return (slide.offsetWidth || slide.$el.offsetWidth) > 0
      })
      const offset = item + spacer
      const totalWidth = offset * this.slideCount
      const margin = Number(this.$refs.theSlider.style.marginLeft.replace(/px/, ''))
      let newMargin = 0

      if (direction === '>') {
        newMargin = margin - offset
      } else {
        // Stop if we are going to go off the front
        if (margin === 0 || margin === '0' || margin === '') {
          return
        }
        newMargin = margin + offset
      }

      // Stop if we are going to go off the end
      if (Math.abs(newMargin) > totalWidth - offset) {
        return
      }

      this.$refs.theSlider.style.marginLeft = newMargin
    }
  }
}
